import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CandidateService {
    constructor(private http: HttpClient) {}

    createCandidate(creatableCandidate: CreatableCandidate): Observable<string> {
        return this.http.post<string>(`${environment.backendUrl}/candidates`, creatableCandidate);
    }

    getAssessmentCenterURL(candidateId: string): Observable<string> {
        return this.http.get<string>(`${environment.backendUrl}/candidates/${candidateId}/assessment-center`);
    }

    createRatingFormSubmission(ratingFormSubmission: RatingFormSubmission): Observable<void> {
        return this.http.post<void>(`${environment.oldBackendUrl}/rating-form/submission`, ratingFormSubmission);
    }

}

export interface CreatableCandidate {
    name: string;
    email: string;
    job: string;
    organization: string;
    returnAssessmentSession?: boolean;
    createAssessmentSession: boolean;
    preferredLanguage: string;
    context?: CandidateCreateContext;
}

export interface CandidateCreateContext {
    firstVisitDate?: string;
    firstVisitPage?: string;
}

export interface Candidate {
    gender: string;
    firstName: string;
    lastName: string;
    birthdate: string;
    addressLine1: string;
    addressLine2?: string;
    postalCode: string;
    city: string;
    state?: string;
    country?: string;
    phone?: string;
    experiences: Experience[];
    hasEmploymentPermit: boolean;
    hasAcademicDegree: boolean;
    hasProfessionalEducation: boolean;
    hasHigherEducationEntranceQualification: boolean;
    hasDrivingLicence: boolean;
    germanLanguageKnowledge: boolean;
    source?: string;
}

export interface GetableCandidate extends Candidate {
    id: string;
    name: string;
    isAllowedToUpdate: boolean;
    avatar?: string;
    acceptFileUpload: boolean;
    uploadedFiles: UploadedFile[];
}

export interface Experience {
    id?: string;
    title: string;
    company: string;
    description: string;
    startDate: string;
    endDate?: string;
    type: ExperienceType;
}

export enum ExperienceType {
    Professional = 'professional',
    Education = 'education'
}

export interface ContactFormSubmission {
    name: string;
    email: string;
    phone: string;
    company: string;
    context?: object;
}

export interface RatingFormSubmission {
    name: string;
    message: string;
    rating: number;
    context?: object;
}

export interface UploadedFile {
    id?: string;
    name: string;
}
